const baseURL = process.env.REACT_APP_BASE_URL + 'talent/';

export async function get_all_cards (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'get_all_cards');
    return result;
}



export async function card_list_csv (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadCSV (data, 'card_list_csv');
    return result;
}


export async function update_member (token, memberId, newCosto) {
    const data = new FormData();
    data.append('token', token);
    data.append('memberId', memberId);
    data.append('newCosto', newCosto);
    let result = await loadJson (data, 'update_member');
    return result[0];
}


export async function load_movements (token, movements) {
    const data = new FormData();
    data.append('token', token);
    data.append('movements', JSON.stringify(movements));
    let result = await loadJson (data, 'load_movements');
    return result[0];
}



export async function list_all_strategies_history (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'list_all_strategies_history');
    return result;
}


export async function load_awards_log (token, awarded_usr_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('awarded_usr_id', awarded_usr_id);
    let result = await loadJson (data, 'load_awards_log');
    return result;
}

export async function get_awards_count (token, awarded_usr_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('awarded_usr_id', awarded_usr_id);
    return await loadJson(data, 'get_awards_count');
}

export async function add_internal_award (token, awarded_usr_id, comment) {
    const data = new FormData();
    data.append('token', token);
    data.append('awarded_usr_id', awarded_usr_id);
    data.append('comment', comment);
    let result = await loadJson (data, 'add_internal_award');
    return result;
}

export async function ensure_card (token, trello_card_id, card_name, short_url, descript, kr_trello_id, options = {}) {
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', trello_card_id);
    data.append('card_name', card_name);
    if (short_url != null && short_url !== '') data.append('short_url', short_url);
    if (descript != null && descript !== '') data.append('descript', descript);
    if (kr_trello_id != null && kr_trello_id !== '' && !(options.private === true || options.private === 1 || options.private === '1')) {
        data.append('kr_trello_id', kr_trello_id);
    }
    if (options.private === true || options.private === 1 || options.private === '1') {
        data.append('private', '1');
    }
    if (options.set_creator === true || options.set_creator === 1 || options.set_creator === '1') {
        data.append('set_creator', '1');
    }
    return await loadJson (data, 'ensure_card');
}


export 
function get_base_url () {
   
    return baseURL;
}

export async function get_all_stocks (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_all_stocks');
}

export async function get_member_stocks (token, member_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('member_id', member_id);
    return await loadJson (data, 'get_member_stocks');
}


export async function delete_stock_document (token, comprobante2delete) {
    const data = new FormData();
    data.append('token', token);
    data.append('comprobante2delete', comprobante2delete);
    return await loadJson (data, 'delete_stock_document');
}



export async function get_all_members (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_all_members');
}


export async function newStockTransaction (token, source_id, destination_id, file, amount, comments) {
    const data = new FormData();
    data.append('token', token);
    data.append('source_id', source_id);
    data.append('file', file);
    data.append('destination_id', destination_id);

    data.append('amount', amount);
    data.append('comments', comments);

    return await loadJson (data, 'newStockTransaction');
}

export async function get_current_cards (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_current_cards');
}




export async function create_new_task (token, text, options = {}) {
    const data = new FormData();
    data.append('token', token);
    data.append('text', text);
    if (options.task_description != null && options.task_description !== '') {
        data.append('task_description', options.task_description);
    }
    if (options.opportunity_id != null && options.opportunity_id !== '') {
        data.append('opportunity_id', String(options.opportunity_id));
    }
    if (options.card_id != null && String(options.card_id).trim() !== '') {
        data.append('card_id', String(options.card_id).trim());
    }
    if (options.trello_card_id != null && String(options.trello_card_id).trim() !== '') {
        data.append('trello_card_id', String(options.trello_card_id).trim());
    }
    if (options.due_date != null && options.due_date !== '') {
        data.append('due_date', String(options.due_date));
    }
    if (options.assignee_usr_id != null && options.assignee_usr_id !== '') {
        data.append('assignee_usr_id', String(options.assignee_usr_id));
    }
    if (options.private === true || options.private === 1 || options.private === '1') {
        data.append('private', '1');
    }
    return await loadJson (data, 'create_new_task');
}

export async function load_task_summary (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'load_task_summary');
}

export async function load_current_activity (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_current_activity');
}

export async function get_strategy_activity_map (token, days = 15) {
    const data = new FormData();
    data.append('token', token);
    data.append('days', String(days));
    return await loadJson(data, 'get_strategy_activity_map');
}

export async function list_all_users_task (token, filter_complete, days = 15, groupBy = 'creation') {
    const data = new FormData();
    data.append('token', token);
    if (filter_complete)  data.append('filter_complete', filter_complete);
    data.append('days', String(days));
    data.append('group_by', String(groupBy));
    return await loadJson (data, 'list_all_users_task');
}


export async function add_task_rating (token,task_id, calidad, rating) {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', task_id);
    data.append('calidad', calidad);
    data.append('rating', rating);
    return await loadJson (data, 'add_task_rating');
}
export async function task_log (token, taskId, log, additional_info, task_name) {
    const data = new FormData();
    data.append('token', token);
    data.append('taskId', taskId);
    data.append('log', log);
    data.append('additional_info', additional_info);
    data.append('task_name', task_name);
    
    return await loadJson (data, 'task_log2');
}

export async function get_notifications (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'get_notifications');
}

export async function mark_notification_attended (token, notificationId) {
    const data = new FormData();
    data.append('token', token);
    data.append('notification_id', notificationId);
    return await loadJson(data, 'mark_notification_attended');
}

export async function delete_task (token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson (data, 'delete_task');

  
}

export async function update_task (token, text, completed, id, active, trello_card_id, opportunity_id, card_id) {

    const data = new FormData();
    data.append('token', token);
    data.append('text', text);
    data.append('completed', completed);
    data.append('id', id);
    data.append('active', active);
    data.append('trello_card_id', trello_card_id == null ? '' : String(trello_card_id));
    data.append('opportunity_id', opportunity_id == null || opportunity_id === '' ? '' : String(opportunity_id));
    if (card_id != null && card_id !== '' && String(card_id).trim() !== '') {
        data.append('card_id', String(card_id).trim());
    } else {
        data.append('card_id', '');
    }
    return await loadJson (data, 'update_task');

  
}

export async function save_push_notification_token(token, firebaseToken, deviceType = 'web') {
    const data = new FormData();
    data.append('token', token);
    data.append('fcm_token', firebaseToken);
    if (deviceType) {
        data.append('device_type', deviceType);
    }
    return await loadJson(data, 'save_push_notification_token');
}

export async function list_task_categories(token, usr_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('usr_id', String(usr_id ?? ''));
    const result = await loadJson(data, 'list_task_categories');
    const list = Array.isArray(result) ? result : (result && Array.isArray(result.categories) ? result.categories : []);
    return list;
}

export async function create_task_category(token, category_name, color) {
    const data = new FormData();
    data.append('token', token);
    data.append('category_name', category_name);
    data.append('color', color || '#6b7280');
    return await loadJson(data, 'create_task_category');
}

export async function update_task_category(token, id, category_name, color) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('category_name', category_name);
    data.append('color', color || '#6b7280');
    return await loadJson(data, 'update_task_category');
}

export async function delete_task_category(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson(data, 'delete_task_category');
}

export function formatoDuracion(totalMinutes) {

    const totalMinutesEnteros = parseInt(totalMinutes, 10);
    // Asegurarse de que la entrada es un número positivo
    if (typeof totalMinutesEnteros !== 'number' || totalMinutesEnteros < 0 || !Number.isInteger(totalMinutesEnteros)) {
      // Podrías manejar el error de otra forma, pero esto asegura un resultado predecible
      return "0m";
    }
  
    // Si los minutos son 0, retorna '0m'
    if (totalMinutesEnteros === 0) {
      return "0m";
    }
  
    // Calcular las horas enteras
    const horas = Math.floor(totalMinutesEnteros / 60);
  
    // Calcular los minutos restantes
    const minutos = totalMinutesEnteros % 60;
  
    let resultado = "";
  
    // Si hay horas, agregar al resultado
    if (horas > 0) {
      resultado += `${horas}h`;
    }
  
    // Si hay minutos, y las horas no están vacías, agregar un espacio
    if (minutos > 0) {
      if (horas > 0) {
        resultado += " ";
      }
      resultado += `${minutos}m`;
    }
    
    // Si la duración es menor a 1 hora (ejemplo: 45 minutos) y el resultado está vacío
    // (lo cual no debería pasar con esta lógica, pero es un seguro)
    if (resultado === "" && minutos > 0) {
        resultado += `${minutos}m`;
    }
    
    // Si solo el valor son horas exactas (ejemplo: 120 minutos)
    if (resultado === "" && horas > 0) {
        resultado += `${horas}h`;
    }
  
  
    return resultado;
  }

export async function load_task_list (token, usr_id, personalOnly = true, assigneeFilterIds = null, onlyPending = false) {
    const data = new FormData();
    data.append('token', token);
    data.append('usr_id', usr_id);
    data.append('personal', personalOnly ? '1' : '0');
    if (onlyPending) {
        data.append('only_pending', '1');
    }
    if (Array.isArray(assigneeFilterIds) && assigneeFilterIds.length > 0) {
        const ids = assigneeFilterIds
            .map((x) => Number(x))
            .filter((x) => Number.isFinite(x) && x > 0);
        if (ids.length > 0) {
            data.append('assignee_filter_ids', JSON.stringify([...new Set(ids)]));
        }
    }
    return await loadJson (data, 'load_task_list');
}

/** Actualiza talent_db.cards.status (0 ninguno, 1 alineación, 2 ejecución, 3 terminado, 4 archivado). */
export async function updateCardStatus (token, trello_card_id, status, card_db_id = null) {
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', trello_card_id == null ? '' : String(trello_card_id).trim());
    data.append('card_status', String(Number(status)));
    const cid = card_db_id != null && card_db_id !== '' ? Number(card_db_id) : 0;
    if (Number.isFinite(cid) && cid > 0) {
        data.append('card_db_id', String(cid));
    }
    return await loadJson(data, 'update_card_status');
}

/** Lista talent_db.krs (id, trello_id, kr_name). */
export async function listKrs (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'list_krs');
}

/** Asigna o quita KR en talent_db.cards (kr_trello_id vacío → NULL). */
export async function updateCardKr (token, trello_card_id, kr_trello_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', String(trello_card_id).trim());
    data.append('kr_trello_id', kr_trello_id != null ? String(kr_trello_id).trim() : '');
    return await loadJson(data, 'update_card_kr');
}

/** Actualiza talent_db.cards.descript (vacío → NULL en servidor). */
export async function updateCardDescription (token, trello_card_id, descript) {
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', String(trello_card_id).trim());
    data.append('descript', descript != null ? String(descript) : '');
    return await loadJson(data, 'update_card_description');
}

export async function listCardComments (token, trello_card_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', String(trello_card_id).trim());
    return await loadJson(data, 'list_card_comments');
}

export async function addCardComment (token, trello_card_id, comments) {
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', String(trello_card_id).trim());
    data.append('comments', comments != null ? String(comments) : '');
    return await loadJson(data, 'add_card_comment');
}

/** Tareas de otros usuarios en la misma estrategia (Mis goals). */
export async function listStrategyTeamTasks (token, usr_id, strategy_mode, trello_card_id, opportunity_id = '') {
    const data = new FormData();
    data.append('token', token);
    data.append('usr_id', String(usr_id));
    data.append('strategy_mode', strategy_mode);
    data.append('trello_card_id', trello_card_id != null ? String(trello_card_id) : '');
    if (strategy_mode === 'opportunity') {
        data.append('opportunity_id', opportunity_id != null ? String(opportunity_id) : '');
    }
    return await loadJson(data, 'list_strategy_team_tasks');
}

/** Reasignar tarea: actualiza solo el responsable (usr_id); el creador no cambia. */
export async function reassignTaskAssignee (token, task_id, assignee_usr_id, strategy_mode, trello_card_id, opportunity_id = '') {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', String(task_id));
    data.append('assignee_usr_id', String(assignee_usr_id));
    data.append('strategy_mode', strategy_mode);
    data.append('trello_card_id', trello_card_id != null ? String(trello_card_id) : '');
    if (strategy_mode === 'opportunity') {
        data.append('opportunity_id', opportunity_id != null ? String(opportunity_id) : '');
    }
    return await loadJson(data, 'reassign_task_assignee');
}

export async function get_task_time_stats (token, dateFrom, dateTo, usrId = null, taskIds = null) {
    const data = new FormData();
    data.append('token', token);
    data.append('date_from', dateFrom);
    data.append('date_to', dateTo);
    if (usrId != null) data.append('usr_id', usrId);
    if (taskIds != null && Array.isArray(taskIds) && taskIds.length > 0) {
        data.append('task_ids', JSON.stringify(taskIds));
    }
    return await loadJson (data, 'get_task_time_stats');
}

export async function update_task_session_endtime (token, event_id, new_datetime) {
    const data = new FormData();
    data.append('token', token);
    data.append('event_id', event_id);
    data.append('new_datetime', new_datetime);
    return await loadJson (data, 'update_task_session_endtime');

  
}

export async function list_task_events (token, task_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', task_id);
    return await loadJson (data, 'list_task_events');
}

export async function update_task_description (token, task_id, task_description) {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', task_id);
    data.append('task_description', task_description);
    return await loadJson (data, 'update_task_description');
}

export async function update_task_name (token, task_id, task_name) {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', String(task_id));
    data.append('task_name', task_name == null ? '' : String(task_name));
    return await loadJson(data, 'update_task_name');
}

export async function update_task_category_link (token, task_id, category_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', String(task_id));
    data.append('category_id', category_id == null ? '' : String(category_id));
    return await loadJson(data, 'update_task_category_link');
}

export async function update_task_due_date (token, task_id, due_date) {
    const data = new FormData();
    data.append('token', token);
    data.append('task_id', String(task_id));
    data.append('due_date', due_date == null || due_date === '' ? '' : String(due_date));
    return await loadJson(data, 'update_task_due_date');
}

export const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};



async function loadCSV(data, url) {
    try {
        const response = await fetch(baseURL + url + ".php", {
            method: 'POST',
            body: data
        });

        if (!response.ok) {
            throw new Error("Error en la respuesta del servidor");
        }

        // Convertir la respuesta en un blob (archivo)
        const blob = await response.blob();

        // Crear una URL para el blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Crear un enlace y simular clic para descargar
        const a = document.createElement("a");
        a.href = blobUrl;
        const today = new Date();
        const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${
            (today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear().toString().slice(-2)}`;

            a.download = `all_cards_${formattedDate}.csv`; // Nombre del archivo con fecha
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Liberar el blob
        window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
        console.error("Error:", error);
    }
}

async function loadJson (data, url) {

    try {
        
        const response = await fetch(baseURL + url + ".php", {
            method: 'POST',
            body: data
        });
        const resp = await response.text();

        if(resp !== "INVALID"){
            try{
                const jsonResult = JSON.parse(resp);
                return jsonResult;
            }catch(err){
                return resp;
            }
            
        }else{
            return "INVALID";
        }
       
    } catch (error) {
        console.error('Error:' + error);
        return null;
    }
}